module.exports = __webpack_public_path__ + "static/img/sj_js_1.ce95769.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sj/sj_js_1.png
// module id = GISs
// module chunks = 1